import React, {FC} from "react";
import {
  getLabelName,
  isArabicCurrentLanguage,
  formatValue,
} from "../../../utils";
import { Form } from "react-bootstrap";
import { CommonTextBoxProps } from "./commonTextBoxProps";


export const TextBoxV1: FC<CommonTextBoxProps> = ({
                                                    labelName,
                                                    inputName,
                                                    inputValue,
                                                    errorText,
                                                    placeHolder,
                                                    isMandatory = false,
                                                    isReadOnly = false,
                                                    isVisible = true,
                                                    type = "text",
                                                    onChange,
                                                    onBlur,
                                                    onKeyPress,
                                                    controlSize = "col flex-form-control",
                                                    labelSize = "form-label",
                                                    inputRef,
                                                    formatType = "none",
                                                    preventNegative = false,
                                                      trackValueChangeOnBlur = true,
                                                    inputContainerClassName,className,
                                                      autoComplete="off",
                                                    row = 3,style
                                                  }) => {
  if (!isVisible) return null;
  //#region variables
  const cssPrefix: string = isArabicCurrentLanguage() ? "_ar" : "_en";
  const errorClassName =
    errorText !== null && errorText !== undefined
      ? `error${cssPrefix}`
      : `success${cssPrefix}`;
  const inputClassName: string =className !=null && className !=""?className:
      type === "checkbox" ? "" : `form-control ${errorClassName}`;
  const isInputField: boolean =
    type !== "textarea";
  const translatedPlaceholder = getLabelName(placeHolder || labelName);
  //#endregion
  //#region function
  const getInputAttributes = () => {
    const baseAttributes = {
      id: inputName,
      name: inputName,
      className: inputClassName,
      placeholder: getLabelName(placeHolder || labelName),
      readOnly: isReadOnly,
      onChange,
      onBlur,
      onKeyDown: handleKeyDown,
      onWheel: (event: React.WheelEvent<HTMLInputElement>) => {
        event.currentTarget.blur();
      },
      ref: inputRef,
    };

    if (type === "price") {
      return {
        ...baseAttributes,
        type: "number",
        min: preventNegative ? "0" : undefined,
        step: "0.01", // Allows for 2 decimal places
        value: formatValue(inputValue, formatType)
      };
    }

    if (type === "quantity") {
      return {
        ...baseAttributes,
        type: "number",
        min: "0",
        step: "1",
        value: formatValue(inputValue, formatType)
      };
    }

    if (type === "number") {
      return {
        ...baseAttributes,
        type: "number",
        min: "0",
        step: "0.00001",
        value: formatValue(inputValue, formatType)
      };
    }

    if (type === "checkbox") {
      return {
        ...baseAttributes,
        type: "checkbox",
        checked: Boolean(inputValue)
      };
    }

    // Default case for text, password, etc.
    return {
      ...baseAttributes,
      type: type || "text",
      value: formatValue(inputValue, formatType)
    };
  };


  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (preventNegative && (type === "number" || type === "quantity" || type === "price")) {
      if (event.key === "-" || event.key === "e") {
        event.preventDefault();
        return;
      }
    }
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default behavior of Enter key (form submission)
      if (onKeyPress) {
        const value = event.currentTarget.value; // Get the current value of the input
        onKeyPress(value); // Pass the value to the onEnterKeyPress function
      }
    }
  };
  const renderError = () => {
    if (errorText) {
      return (
        <Form.Control.Feedback
          type="invalid"
          className="position-relative d-block"
        >
          {errorText}
        </Form.Control.Feedback>
      );
    }
    return null;
  };
  //#endregion
  //#region html
  return (
    <>
      <div className={controlSize} style={{ gap: 15, alignItems: "baseline" }}>
        {labelName && (
          <label htmlFor={inputName} className={labelSize}>
            {getLabelName(labelName)}
            {isMandatory && <span className="asterisk">*</span>}
          </label>
        )}
        <div className={ inputContainerClassName ? inputContainerClassName : "flex-grow-1"}>
          {isInputField && (
            <input
                // @ts-ignore
              {...getInputAttributes()}
              // type={type}
              // min={type === "number" ? "0" : "-1000000"}
              // step={type === "number" ? "0.00001" : undefined}
              id={inputName}
              key={inputName}
              name={inputName}
              className={inputClassName}
              placeholder={translatedPlaceholder}
              readOnly={isReadOnly}
              checked={type === "checkbox" && Boolean(inputValue)}
              // @ts-ignore
              value={
                type !== "checkbox"
                  ? formatValue(inputValue, formatType)
                  : inputValue
              }
              // @ts-ignore
              onChange={onChange}
              // @ts-ignore
              onBlur={onBlur}
              onKeyDown={handleKeyDown} // Attach the event handler
              onWheel={(event) => {
                event.currentTarget.blur();
              }}
              ref={inputRef}
              style={style}
              autoComplete={autoComplete}
            />
          )}

          {!isInputField && (
            <textarea
              id={inputName}
              key={inputName}
              name={inputName}
              className={inputClassName}
              rows={row}
              placeholder={translatedPlaceholder}
              readOnly={isReadOnly}
              // @ts-ignore
              value={formatValue(inputValue || "")}
              // @ts-ignore
              onChange={onChange}
              // @ts-ignore
              onBlur={onBlur}
              style={{ width: "100%" }}
            />
          )}
          {renderError()}
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
    </>
    //#endregion
  );
};
